import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { CreateDashboardValidationSchema } from '../../schemas/dashboards/dashboard.schema';

interface UseCreateDashboardProps {
  options?: Partial<Omit<UseMutationOptions<
    AxiosResponse,
    ErrorResponse,
    CreateDashboardValidationSchema
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useCreateDashboard = ({ options }: UseCreateDashboardProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createDashboard'],
    mutationFn: (form) => {
      return privateAxios.post('/dashboards', {
        dashboard: {
          display_name: form.display_name?.trim(),
        },
      });
    },
    ...options,
  });
}
